/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Summaryplusones2Inputs */

const en_summaryplusones2 = /** @type {(inputs: Summaryplusones2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus-ones up to ${i?.count}`)
};

const de_summaryplusones2 = /** @type {(inputs: Summaryplusones2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Begleitung bis ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Plus-ones up to {count}" |
*
* @param {Summaryplusones2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summaryplusones2 = /** @type {((inputs: Summaryplusones2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summaryplusones2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summaryplusones2(inputs)
	return de_summaryplusones2(inputs)
});
export { summaryplusones2 as "summaryPlusOnes" }